import React from 'react'

interface NewsletterProps {
  buttonColor: string
}

const Newsletter: React.FC<NewsletterProps> = ({ buttonColor }) => (
  <div style={{ backgroundColor: buttonColor }}>
    <div className="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Want to Stay in Touch?
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-white opacity-90">
          Subscribe to our Newsletter! No spam guaranteed!
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <div className="flex w-full max-w-md">
            <input
              type="email"
              placeholder="Enter your email"
              className="min-w-0 flex-auto rounded-l-md border-0 bg-white px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-white sm:text-sm sm:leading-6"
            />
            <button
              className="flex-none rounded-r-md bg-white px-3.5 py-2.5 text-sm font-semibold shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              style={{ color: buttonColor }}
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Newsletter
